import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { IconVerfied } from '@prisjakt/ui/icon';
import { FontEmphasis } from '@prisjakt/ui/text';
import { CaptionText } from '@prisjakt/ui/text/variants';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import { IconWrapper, PriceInfoElement } from './styles';

type Props = {
  showCaptionText?: boolean;
};

export const RecommendedRetailerBadge: React.FC<Props> = props => {
  const { showCaptionText = true } = props;
  const { t } = useAppContext();

  return (
    <PriceInfoElement>
      <Tooltip
        placement={TooltipPlacement.TOP}
        title={t('store', 'brand.recommended-retailer')}
        renderOnMouseOver
      >
        <IconWrapper>
          <IconVerfied color="base300" />
        </IconWrapper>
      </Tooltip>
      {showCaptionText && (
        <CaptionText emphasis={FontEmphasis.MEDIUM}>
          {t('store', 'brand.recommended-retailer')}
        </CaptionText>
      )}
    </PriceInfoElement>
  );
};
